import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ url, image, text, alt }) => {
  return (
    <div className="max-w-xs mx-auto">
      <Link to={url}>
        <div className="rounded-lg bg-gray-50 hover:bg-gray-200 shadow-sm ring-1 ring-gray-900/5">
        <div className="relative rounded-t-lg">

          <img src={image} alt={alt} className="w-full object-cover rounded-t-lg" />
          <div className="absolute inset-0 bg-gray-200 opacity-10 hover:opacity-0 rounded-t-lg"></div>
        </div>
          <div className="border-t border-gray-900/5 px-6 py-6">
            <h2 className="text-xl font-semibold text-sky-900">{text}<span aria-hidden="true">&rarr;</span></h2>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default Card;
